import * as React from 'react';
import { DropDownListComponent } from '../DropDownList/DropDownListComponent';
import { ItemList } from '../../types/logbook-type';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { useOrganizationList } from '../../data/DataProviders/OrganizationListProvider';

export interface Props {
    defaultValue: string;
    callback: () => void;
    disabled?: boolean;
}

const SLAFilterSelect: React.FunctionComponent<Props> = (props) => {

    const { defaultValue, callback, disabled = false } = props;
    
    const { t } = useLanguageLocale();
    const useOrganizationDataList = useOrganizationList();

    const [slaListData, setSLAListData] = React.useState<ItemList>([]);

    React.useEffect(() => {
        setSLAListData(useOrganizationDataList.organizationList);
    }, [useOrganizationDataList, useOrganizationDataList.organizationList]); //eslint-disable-line react-hooks/exhaustive-deps

    return (
        <DropDownListComponent
            disabled={disabled}
            data-testid="asset-SLA-filter"
            list={slaListData}
            value={t('SEARCH.ALL_SLA')}
            handleSelection={callback}
            selected={''}
            defaultSelection={defaultValue}>
        </DropDownListComponent>
    );
};

export default SLAFilterSelect;
